export function groupTypes(state = [], action) {
  const { detail } = action;
  switch (action.type) {
    case 'LOAD_GROUP_TYPES':
      return detail;
    default:
      return state;
  }
}
